import Swal from 'sweetalert2/src/sweetalert2.js'
import axios from "axios";

export default function useSwal() {
  const showConfirmationDialog = (
    title,
    text,
    icon,
    showCancelButton = true,
  ) => {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title,
        text,
        icon,
        showCancelButton,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
      })
        .then((response) => {
          if (response.isConfirmed) resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }

  const showSuccessDialog = () => {
    Swal.fire('', 'Ação realizada com sucesso', 'success')
  }

  const showErrorDialog = (details = null) => {
    Swal.fire({
      icon: 'error',
      text: 'Erro ao tentar realizar ação',
      footer: details,
    })
  }

  const showConfirmDeletionSwal = () => {
    const title = 'Tem certeza que deseja excluir?'
    const text = 'Não será possível reverter essa decisão!'
    const icon = 'warning'

    return showConfirmationDialog(title, text, icon)
  }

  const showSuccessAlert = () => {
    Swal.fire('Ação realizada com sucesso!', '', 'success')
  }

  const showErrorAlert = () => {
    Swal.fire('Erro ao tentar efetuar esta ação', '', 'error')
  }

  const showAjaxDialog = (request) => {
    return new Promise((resolve, reject) => {
      Swal.fire({
          title: 'Tem certeza desta operação?',
          text: 'Verifique todos os campos antes de efetuar o cadastro.',
          confirmButtonText: 'Cadastrar',
          cancelButtonText: 'Cancelar',
          showCancelButton: true,
          showLoaderOnConfirm: true,
          preConfirm: function () {
            return axios
                .post(request.url, request.data, request.config)
                .then((response) => {
                  if (response.isConfirmed) resolve(response)
                })
                .catch(error => {
                  reject(error)
                })
          },
      })
    })
  }

  return {
    showErrorDialog,
    showSuccessDialog,
    showConfirmationDialog,
    showConfirmDeletionSwal,
    showSuccessAlert,
    showErrorAlert,
    showAjaxDialog
  }
}
